import React from 'react';
import { Empty } from 'antd';
import { useDispatch } from 'react-redux';
import { CustomersByOD, FluxClientsFilters } from 'types';
import { isEspagne } from 'common/config/env';

import { customersListActions } from '../../../common/config/store';
import StyledTable from '../../organisms/styled-table';
import { useIntl } from '../../../common/config/i18n';
import { useColumns } from './use-table-columns';
import styles from './styles.module.css';
import PaginationBlock from 'components/molecules/pagination';

type Props = {
  data?: CustomersByOD;
  filterValues?: FluxClientsFilters;
};

const CustomersByODList: React.FC<Props> = (props) => {
  const { t } = useIntl();
  const dispatch = useDispatch();

  const customersByODColumns = useColumns()?.[isEspagne ? 'ES' : 'FR'];

  const data = props?.data;
  const customersByODDataSource = data?.result
    ? data?.result?.map((item, index) => ({
        key: `${item.serviceName}-${index}`,
        ...item,
      }))
    : [];

  return (
    <>
      <PaginationBlock
        data={{ pageNumber: data?.pageNumber, maxPages: data?.maxPages, maxResultPage: data?.maxResultPage }}
        onChange={(page: number, pageSize?: number) =>
          dispatch(
            customersListActions.fetchCustomersByOD({
              ...props.filterValues,
              pageNumber: page,
              maxResultPage: pageSize,
            })
          )
        }
      />
      <StyledTable
        pagination={false}
        dataSource={customersByODDataSource}
        columns={customersByODColumns}
        padding="0"
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
        rowClassName={styles.fluxClientRowClassName}
        className={styles.tableClassName}
      />
      <PaginationBlock
        data={{ pageNumber: data?.pageNumber, maxPages: data?.maxPages, maxResultPage: data?.maxResultPage }}
        onChange={(page: number, pageSize?: number) =>
          dispatch(
            customersListActions.fetchCustomersByOD({
              ...props.filterValues,
              pageNumber: page,
              maxResultPage: pageSize,
            })
          )
        }
      />
    </>
  );
};

export default CustomersByODList;
